<ng-template #maintenance>
  <fcom-icon [name]="SvgLibraryIcon.PET" class="ms-xsmall-b nordic-blue-900-text icon-xlarge"></fcom-icon>
  <h1 class="nordic-blue-900-text ms-medium-b">
    <div [ngSwitch]="errorType" class="font-heading-3">
      {{ 'sorry' | finLocalization }}
    </div>
  </h1>
  <div class="mr-medium-b">
    <cms-unstyled-fragment
      *ngIf="'fragments.oneUpgrade.maintenance.url' | finLocalization as fragment"
      class="block light-type font-body-1"
      [contentUrl$]="fragment | finToObservable"
    >
    </cms-unstyled-fragment>
  </div>
</ng-template>

<ng-template #paymentError>
  <fcom-icon [name]="SvgLibraryIcon.PET" class="ms-xsmall-b nordic-blue-900-text icon-xlarge"></fcom-icon>
  <h1 class="nordic-blue-900-text ms-medium-b">
    <div [ngSwitch]="errorType" class="font-heading-3">
      {{ 'sorry' | finLocalization }}
    </div>
  </h1>
  <div class="mr-medium-b">
    <p>{{ 'oneUpgrade.errors.paymentError' | finLocalization }}</p>
  </div>
</ng-template>

<ng-container *ngIf="upgradeError$ | async as upgradeError">
  <div
    class="border rounded-medium pr-large-y pr-medium-x white-bg"
    [class.align-center]="upgradeError === UpgradeError.paymentError || upgradeError === UpgradeError.maintenance"
  >
    <ng-container [ngSwitch]="upgradeError">
      <ng-container *ngSwitchCase="UpgradeError.maintenance">
        <ng-container *ngTemplateOutlet="maintenance"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="UpgradeError.paymentError">
        <ng-container *ngTemplateOutlet="paymentError"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div id="noAvailability">
          <h2 class="nordic-blue-900-text font-heading-3 mr-xsmall-b inline-block" #noAvailabilityHeader tabindex="-1">
            {{ 'oneUpgrade.' + upgradeError + '.heading' | finLocalization }}
          </h2>
          <p class="mr-large-b">{{ 'oneUpgrade.' + upgradeError + '.paragraph' | finLocalization }}</p>

          <ng-container *ngIf="bookingRef$ | async as bookingRef">
            <h3 class="font-body-1 ms-xxsmall-b">
              {{ 'oneUpgrade.bookingRef' | finLocalization }}
            </h3>
            <p class="mr-medium-b" data-hj-suppress>{{ bookingRef.recLoc | uppercase }}</p>
          </ng-container>

          <ng-container *ngIf="journey$ | async as journey">
            <ng-container *ngIf="journey.locations.length">
              <h3 class="font-body-1 ms-xxsmall-b">
                {{ 'oneUpgrade.tripDetails' | finLocalization }}
              </h3>
              <fin-trip-location-info
                [tripType]="journey.tripType"
                [locations]="journey.locations"
                displayMode="block"
              ></fin-trip-location-info>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <div class="align-right">
      <fcom-button [size]="ButtonSize.LARGE" [text]="cta | finLocalization" (clickBtn)="onStartOver()"> </fcom-button>
    </div>
  </div>
</ng-container>
